import { TGetWhoAmI } from "@elixir/types";

/**
 * Commented out sections are
 * for mxp native bridges
 * which can be added in later
 */

declare global {
  interface Window {
    // @ts-ignore
    mxpDataLayer?: unknown[];
    dataLayer?: unknown[];
  }
}

function pushToMxpDataLayer({ data }: { data: unknown }) {
  if (typeof window !== "undefined") {
    window.mxpDataLayer = window.mxpDataLayer || [];
    window.mxpDataLayer.push(data);
  }
}

function pushToDataLayer({ data }: { data: unknown }) {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
}

const fallback: Array<{ fn: string; params: unknown }> = [];

function fallbackFn(name: string) {
  return function (...params: unknown[]) {
    fallback.push({ fn: name, params });
  };
}

let mixpanel = {
  notInitiated: true, // just a dummy flag to indicate that mixpanel is not initialised
  track: fallbackFn("track"),
  init: fallbackFn("init"),
  identify: fallbackFn("identify"),
  register: fallbackFn("register"),
};

export async function initAnalytics(MIX_PANEL_KEY: string) {
  const { notInitiated = false } = mixpanel; //notInitiated will not be present in actual mixpanel object hence default value is false
  if (MIX_PANEL_KEY && notInitiated) {
    const mxp = (await import("mixpanel-browser")).default;
    mxp.init(MIX_PANEL_KEY);
    mxp.track("analytics-init");
    pushToMxpDataLayer({
      data: {
        name: "analytics-init",
      },
    });
    fallback.forEach((item) => {
      const { fn, params } = item;
      // @ts-ignore
      mxp?.[fn](...params);
    });
    // @ts-ignore
    mixpanel = mxp;
  }
}

export function recordPageView({
  eventName = "page-view",
  pageName = "",
  pageParams = {},
}) {
  const eventData = { ...(!!pageName ? { pageName } : {}), ...pageParams };
  pushToMxpDataLayer({
    data: {
      name: eventName,
      data: eventData,
    },
  });
  pushToDataLayer({ data: { event: eventName, ...eventData } });
  // if (canSendAnalyticsDataToNative()) {
  //   sendAnalyticsData({ eventName, eventData });
  // } else {
  // }
  mixpanel.track(eventName, { pageName, ...pageParams });
}

export function sendUserData({ profile }: { profile: TGetWhoAmI }) {
  if (profile.uuid) {
    pushToMxpDataLayer({
      data: {
        name: "identity",
        data: { id: profile.oid || profile.uuid },
      },
    });
    pushToMxpDataLayer({
      data: {
        name: "register",
        data: profile,
      },
    });
    // if (!canSendAnalyticsDataToNative()) {
    // }
    mixpanel.identify(profile.oid || profile.uuid);
    mixpanel.register(profile);
  }
}

export function sendPlatformData({
  headers,
}: {
  headers: Record<string, any>;
}) {
  pushToMxpDataLayer({
    data: {
      name: "register",
      data: headers,
    },
  });
  // if (!canSendAnalyticsDataToNative()) {
  // }
  mixpanel.register(headers);
}

export function sendClickEvent({
  clickCategory = "click-event",
  clickName,
  pageName,
  clickParams,
}: {
  clickCategory: string;
  clickName: string;
  pageName: string;
  clickParams: object;
}) {
  pushToMxpDataLayer({
    data: {
      name: clickCategory,
      data: { clickName, pageName, ...clickParams },
    },
  });
  const eventName = clickCategory;
  const eventData = { clickName, pageName, ...clickParams };
  pushToDataLayer({ data: { event: eventName, ...eventData } });
  // if (canSendAnalyticsDataToNative()) {
  //   sendAnalyticsData({ eventName, eventData });
  // } else {
  // }
  mixpanel.track(eventName, eventData);
}

export function sendApiFailedEvent({
  category = "api-failed",
  url,
  params,
}: {
  category?: string;
  url: string;
  params: object;
}) {
  pushToMxpDataLayer({
    data: {
      name: category,
      data: { url, ...params },
    },
  });
  const eventName = category;
  const eventData = { url, ...params };
  // if (canSendAnalyticsDataToNative()) {
  //   sendAnalyticsData({ eventName, eventData });
  // } else {
  // }
  mixpanel.track(eventName, eventData);
}
